import styled from "styled-components";

export const ItemTitle = styled.h3`
  border-bottom: 1px solid #95959595;
  padding-bottom: 0.2rem;
`;

export const PageWrapper = styled.div`
  max-width: 1000px;

  & .error-message {
    color: #d10000;
    font-size: 0.9rem;
    vertical-align: super;
    padding-left: 0.25rem;
  }
`;

export const DropzoneWrapper = styled.section`
  & > * {
    padding: 10rem 5rem;
    border-radius: 0.5rem;
    border: 1px solid #cecece;
    background-color: #ececec;
    text-align: center;
  }
`;

export const LoadingWrapper = styled.div`
  z-index: 1001; // menu bar is 1000
  background: rgba(255, 255, 255, 0.75);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
